var React = require('react');

function Benefits (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 4"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Customers-Page","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Careers","transform":"translate(-180.000000, -983.000000)","stroke":"#534DC9","strokeWidth":"2"},React.createElement("polygon",{"id":"Path-4","points":"194.267753 984 206.82694 984 206.82694 996.331644 220 996.331644 220 1007.99749 206.82694 1007.99749 206.82694 1021 194.267753 1021 194.267753 1007.99749 181 1007.99749 181 996.331644 194.267753 996.331644"})))]);
}

Benefits.defaultProps = {"width":"41px","height":"39px","viewBox":"0 0 41 39","version":"1.1"};

module.exports = Benefits;

Benefits.default = Benefits;
